import UserSmallCard from './container';

export default UserSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/UserSmallCard/index.js